import { render, staticRenderFns } from "./target_years.vue?vue&type=template&id=e8887c56&scoped=true"
import script from "./target_years.vue?vue&type=script&lang=js"
export * from "./target_years.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8887c56",
  null
  
)

export default component.exports